import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateHelperService } from '../../services/TranslateService';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/models/user';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AppState } from 'src/app/services/app.service';
import { LanguageService } from 'src/app/services/language.service';
import { McGriffClaimModel, McGriffLossRatio } from './analytics.model';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'self-ins-analytics',
    templateUrl: './analytics-page.component.html',
    styleUrls: ['./analytics-page.component.scss'],
    standalone: false
})
export class AnalyticsPageComponent implements OnInit, AfterViewInit {
    @ViewChild('claimsTable') public claimsSort: MatSort | undefined;
    public user!: User;
    public displayedClaimsColumns = ['claimNumber', 'dateOfLoss', 'claimStatus', 'netIncurred', 'coverage', 'amazonId', 'lossDescription'];
    public displayedLossRatioColumns = ['scac', 'afpName', 'incidents',  'netIncurred'];
    public claims = new MatTableDataSource<McGriffClaimModel>([]);
    public lossRatio: McGriffLossRatio[] = [];
    public claimsGridFilterValue = '';
    public qnum: number = 0;
    public qsuffix: string = '';
    public valueDate: Date | null = null;
    public currentLocale: string = 'en-GB';
    public currentCurrency: string = 'GBP';
    public dateFormat: string = 'dd/MM/y';

    constructor(private appState: AppState,
        private activeRouter: ActivatedRoute,
        private router: Router,
        private analyticsService: AnalyticsService,
        private languageService: LanguageService,
        public _translateService: TranslateHelperService) {
        this.user = this.appState.user.getValue();
    }

    ngOnInit(): void {
        this.currentLocale = this.languageService.getCurrentLocale();
        this.currentCurrency = this.languageService.getCurrentCurrency();
        this.dateFormat = this.languageService.getShortDateFormat();
        
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        });
        forkJoin([
            this.analyticsService.getMcGriffClaims(),
            this.analyticsService.getMcGriffLossRatio()
        ]).subscribe((data) => {
                const [claims, lossRatio] = data;
                this.claims.data = claims;
                this.lossRatio = lossRatio;

                const validClaims = claims.filter(c => c.uploadDate);
                this.valueDate = validClaims.length > 0 
                    ? validClaims.reduce((max, claim) => 
                        new Date(claim.uploadDate) > new Date(max.uploadDate) ? claim : max
                    ).uploadDate
                    : null;
                
            });
    }

    public ngAfterViewInit() {
        this.claims.sort = this.claimsSort || null;
    }

    public applyClaimsFilter() {
        this.claims.filter = this.claimsGridFilterValue.trim().toLowerCase();
    }

    public clearSearch() {
        this.claimsGridFilterValue = '';
        this.applyClaimsFilter();
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}
